export const DOWNLOAD_STEP = {
  STEP_ONE: 'Do you want export CSV file?',
  STEP_TWO: 'Loading data...',
  STEP_THREE: 'Data loaded! Exporting csv...',
};



// WEBPACK FOOTER //
// ./src/pages/PaymentHistoryPage/components/ExportModal/exportModalConst.ts